import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { loadReasons, submitTicket } from '../../redux/modules/ticket'
import {
  findSelectedReason,
  getContactUsQueryParams
} from '../../redux/modules/selectors'

import { InputError } from '@foodsby/nutrient'
import ContactUsForm from './ContactUsForm'

const ContactUsFormContainer = reduxForm({ form: 'contactUs' })(ContactUsForm)

const ContactUsText = () => (
  <div className="row center-xs">
    <div className="row">
      <h2 className="pt-15 primary">WE'RE HERE TO HELP YOU WITH YOUR ORDER!</h2>
    </div>
    <div className="row pb-15">
      <div className="col-xs-12">
        We're sorry if there is a problem with your order. The quickest way to
        address delivery/order problems is to contact the restaurant directly by
        calling the number listed on your order confirmation. You can also
        complete the form below and we will assist you as quickly as possible.
      </div>
    </div>
  </div>
)

const LoadingIndicator = () => (
  <div className="row center-xs middle-xs">
    <i className="spinner spinner-md primary" />
  </div>
)

const FormCard = ({
  initialValues,
  reasons,
  selectedReason,
  onSubmit,
  submitting
}) => (
  <div className="contact-us-card card">
    <h3 className="pt-1">Contact Us</h3>
    <div>
      <ContactUsFormContainer
        initialValues={initialValues}
        reasons={reasons}
        selectedReason={selectedReason}
        onSubmit={onSubmit}
        submitting={submitting}
      />
    </div>
  </div>
)

class ContactUs extends Component {
  componentDidMount() {
    this.props.loadReasons()
  }

  render() {
    const {
      loading,
      initialValues,
      reasons,
      selectedReason,
      submitTicket,
      error,
      submitting
    } = this.props
    return (
      <div className="container-fluid contact-us">
        <ContactUsText />
        {loading ? (
          <LoadingIndicator />
        ) : (
          <FormCard
            initialValues={initialValues}
            reasons={reasons}
            selectedReason={selectedReason}
            onSubmit={submitTicket}
            submitting={submitting}
          />
        )}

        {error && (
          <InputError visible={error && error !== null}>
            {error.message}
          </InputError>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reasons, loading, submitting, error } = state.ticket

  return {
    initialValues: getContactUsQueryParams(state, ownProps),
    reasons,
    loading,
    error,
    submitting,
    selectedReason: findSelectedReason(state)
  }
}

const mapDispatchToProps = {
  loadReasons,
  submitTicket
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs)
